<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">Data Signal Overview </h2>
    </div>
  </div>
  <div class="rbqm-root">
    <!-- Summary Cards -->
    <div class="container p-0 pt-2">
      <div class="grid">
        <div class="rbqm-card span-3 cursor-pointer" @click="openSiteSummary()">
          <h3>Total Sites</h3>
          <div class="risk-score " >
            {{ siteCount }}
          </div>
          <small>KPI Analysed Sites</small>
        </div>

        <div class="rbqm-card span-3 cursor-pointer " @click="openCriticalSites()">
          <h3>Total Critical Signals</h3>
          <div class="risk-score txt-critical" >
            {{ signalCount }}
          </div>
          <small>Sites Affected by Critical Signals</small>
        </div>

        <div class="rbqm-card span-3 cursor-pointer" @click="openCorrelationSites()">
          <h3>Correlation-Affected Sites</h3>
          <div class="risk-score " >
            {{ correlationCount }}
          </div>
          <small>KPI-Based Correlation Analysis (Sites)</small>
        </div>
        <div class="rbqm-card span-3 cursor-pointer" @click="openRepatetionSites()">
          <h3>Repetition-Affected Sites</h3>
          <div class="risk-score " >
            {{ repatitionCount }}
          </div>
          <small>Repetition Detection Sites</small>
          <!-- <div>10</div>
          <small>Average Risk Score: 50</small> -->
        </div>
      </div>
    </div>
    <!-- Data Signal  -->
    <div class="wrapper wrapper-content px-0">
      <div class="modal-table-container">
        <div class="section-title">
          <span>Data Signals</span>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th class="text-center">Technique Name</th>
                <th class="text-center">Site Affected</th>
                <th class="text-center">Site Not Affected</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="technique in transformedTechniqueData" :key="technique.techniqueName">
                <td class="text-center">{{ technique.techniqueName }}</td>
                <td class="text-center cursor-pointer text-primary"
                  @click="openSiteAffectedModal(technique.techniqueName)" style="text-decoration: underline;">
                  {{ technique.siteAffected }}
                </td>
                <td class="text-center cursor-pointer text-primary"
                  @click="openSiteNotAffectedModal(technique.techniqueName)" style="text-decoration: underline;">
                  {{ technique.siteNotAffected }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="rbqm-card col-lg-6 chart-card">
        <div class="chart-wrap">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">Site Wise Data Signals</h3>
          </div>
          <apexchart 
            v-if="criticalSignalSeries.length" 
            type="bar" 
            height="350" 
            :options="criticalSignalOptions"
            :series="criticalSignalSeries" 
          />
          <div v-else class="text-muted p-3">No data</div>
        </div>
      </div>
      <div class="rbqm-card col-lg-6 chart-card">
        <h3 class="mb-2">Critical Data Signal Trend</h3>

        <apexchart v-if="criticalSignalTrendSeries.length" type="line" height="350"
          :options="criticalSignalTrendOptions" :series="criticalSignalTrendSeries" />

        <div v-else class="text-muted p-3">No trend data</div>
      </div>
    </div>

  </div>

  <!-- Site Affected Details Modal -->
  <SiteAffectedDetailsModal 
    v-if="showSiteAffectedModal" 
    :techniqueName="selectedTechniqueName"
    :detailsData="siteAffectedDetails" 
    :modalType="'affected'" 
    @closeModal="closeSiteAffectedModal" 
  />

  <!-- Site Not Affected Details Modal -->
  <SiteAffectedDetailsModal 
    v-if="showSiteNotAffectedModal" 
    :techniqueName="selectedTechniqueName"
    :detailsData="siteNotAffectedDetails" 
    :modalType="'notaffected'" 
    @closeModal="closeSiteNotAffectedModal" 
  />

  <siteSummary 
    v-if="showSiteSummary" 
    :data="siteSummary" 
    @close-modal="closeModal()" 
  />
  <criticalSignal 
    v-if="showCriticalSites" 
    :data="siteSummary" 
    :heading= "'Critical Signals'"
    @close-modal="closeCriticalSites()" 
  />
  <criticalSignal 
    v-if="showCorerelationSites" 
    :data="correlationSummary" 
    :heading= "'Correlation Signals'"
    @close-modal="closeCorrelationSites()" 
  />
  <criticalSignal 
    v-if="showRepatetionSites" 
    :data="repatetionSummary" 
    :heading= "'Repetition Signals'"
    @close-modal="closeRepatetionSites()" 
  />
</template>
<script src="./DataSignalOverview.js"></script>
<style scoped>
/* Root wrapper for this component only */
.rbqm-root {
  margin: 0;
  font-family: "Segoe UI", Roboto, Arial, sans-serif;
  background: #f4f6f9;
  color: #1f2937;
  padding-bottom: 16px;
}

/* Avoid overriding Bootstrap .container */
.rbqm-container {
  padding: 20px 0;
}

/* Grid tiles */
.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
}

/* Use a dedicated class instead of overriding Bootstrap .card */
.rbqm-card {
  background: #fff;
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(17, 24, 39, 0.06);
  height: 90px;
}

.rbqm-card h3 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

.cursor-pointer {
  cursor: pointer;
}

/* Risk score */
.risk-score {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  margin: 8px 0;
}

.risk-high {
  color: #dc2626;
}

.risk-medium {
  color: #f59e0b;
}

.risk-low {
  color: #16a34a;
}

/* Grid spans */
.span-3 {
  grid-column: span 3;
}

.span-6 {
  grid-column: span 6;
}

.span-9 {
  grid-column: span 9;
}

.span-12 {
  grid-column: span 12;
}

@media (max-width: 992px) {

  .span-3,
  .span-6,
  .span-9,
  .span-12 {
    grid-column: span 12;
  }
}

/* Chart card */
.chart-card {
  margin-top: 16px;
  background: #fff;
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(17, 24, 39, 0.06);
  height: 400px;

}

/* Chart container to prevent overflow on small screens */
.chart-wrap {
  width: 100%;
  overflow-x: auto;
}

/* Utility styles you had */
.highrisk {
  background-color: #f22613;
}

.mediumrisk {
  background-color: #f5d76e;
}

.safe {
  background-color: #87d37c;
}

.inround {
  width: 50px;
  border-radius: 10%;
}     
.txt-critical{
  color: red !important;
}
</style>